import OnlinePayment from 'pages/integration/features/online-payment';
import Integration from 'pages/integration/Integration';

import AmoCrm from 'components/integration/amoCrm/AmoCrm';
import BotConfig from 'components/integration/bot/BotConfig';
import BotInterface from 'components/integration/bot/BotInterface';
import MarketPlace from 'components/integration/marketPlace/MarketPlace';
import WebSite from 'components/integration/webSite/WebSite';

import { IntegrationPaths } from './integrationPaths';

export const IntegrationRoutes = [
  {
    component: Integration,
    path: IntegrationPaths.INDEX,
    exact: true
  },
  {
    component: BotConfig,
    path: IntegrationPaths.TELEGRAM,
    exact: true
  },
  {
    component: WebSite,
    path: IntegrationPaths.WEB_SITE,
    exact: true
  },
  {
    component: AmoCrm,
    path: IntegrationPaths.AMO_CRM,
    exact: true
  },
  {
    component: BotInterface,
    path: IntegrationPaths.TELEGRAM + IntegrationPaths.BOT_INTERFACE,
    exact: true
  },
  {
    component: MarketPlace,
    path: IntegrationPaths.MARKET_PLACE,
    exact: true
  },
  {
    component: OnlinePayment,
    path: '/integration-config/online-paymnet',
    exact: true
  }
];
